import up from 'unpoly';

import 'unpoly/unpoly-migrate.js';

import '../../css/front/entrypoint.scss';

import '../compilers/index.js';
import Alpine from '../alpinejs/index.js';

import '../shared/root-width.js';
import './imbox.ts';
import './tracking.ts';
import './form-submit-handlers/index.ts';
import './misc/fix-safari-print.js';
import { saveUtmParams } from './tracking.ts';
import './views/blocks/animated-banner.js';
import './views/blocks/countdown.js';
import './views/blocks/pardot-form-solutions-2.ts';
import './views/components/applications/application-file-upload-control.js';
import './views/components/blocks/carousel.ts';
import './views/components/blocks/course-filter.js';
import './views/components/blocks/google-sheets-form.ts';
import './views/components/blocks/newsletter-signup.ts';
import './views/components/blocks/pardot-form.ts';
import './views/components/boxes/box-email-form.ts';
import './views/components/forms/precognitive/form.js';
import './views/components/forms/precognitive/phone-number-control.js';
import './views/components/layout/expandable.ts';
import './views/components/misc/reveal-button.js';
import './views/components/templates/applications/application-files-template.js';
import './views/templates/search.js';

saveUtmParams();

up.fragment.config.runScripts = true;
up.history.config.updateMetaTags = true;
up.log.config.format = false;
up.log.enable();

window.Alpine = Alpine;

Alpine.start();
